/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import SwiperNavigationButton from '../components/layouts/SwiperNavigationButton';
import BoxedContainer from '../components/layouts/BoxedContainer';
import GalleryBlockModal from './GalleryBlockModal';

export default function GalleryBlock({ data }) {
  const [swiper, setSwiper] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const handleClickNext = () => swiper?.slideNext();
  const handleClickPrev = () => swiper?.slidePrev();
  useEffect(() => {
    setSelectedImage(0);
  }, []);

  const activeSlideNumber = selectedImage + 1;
  const [modalIndex, setModalIndex] = useState(-1);
  const closeModal = () => setModalIndex(-1);
  const openModal = (index) => setModalIndex(index);

  useEffect(() => {
    if (modalIndex >= 0) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [modalIndex]);

  const breakpoints = {
    320: {
      slidesPerView: 1.6,
      slidesPerGroup: 1,
      pagination: true,
      centeredSlides: true,
    },
    640: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      pagination: true,
      centeredSlides: true,
    },
    768: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      pagination: true,
      centeredSlides: true,
    },
    992: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      pagination: true,
      centeredSlides: false,
    },
    1100: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      pagination: true,
      spaceBetween: 30,
      centeredSlides: false,
    },
    1368: {
      slidesPerView: 5,
      slidesPerGroup: 1,
      pagination: true,
      spaceBetween: 30,
      centeredSlides: false,
    },
  };

  return (
    <section
      className={`lg:pt-[100px] pt-[60px] relative ${
        data.paddingBottom ? 'lg:pb-[220px] pb-[90px]' : 'lg:pb-[140px] pb-[70px]'
      }
      ${data.isSportsDetails ? 'lg:!pb-[100px] pb-[70px]' : ''}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className="flex items-center relative"
      >
        <Swiper
          breakpoints={breakpoints}
          onSlideChange={(_swiper) => setSelectedImage(_swiper.realIndex)}
          onSwiper={setSwiper}
          loop
          className="mySwiper relative swiper-wrapper-slide:before:content-['']
          swiper-wrapper-slide:md:before:bg-opacity-0
          swiper-wrapper-slide:before:!inline swiper-wrapper-slide:before:w-full
          swiper-wrapper-slide:before:h-full swiper-wrapper-slide:before:bg-black
          swiper-wrapper-slide:before:bg-opacity-50 swiper-wrapper-slide:before:absolute
          swiper-wrapper-slide:before:top-0 swiper-wrapper-slide-active:before:bg-opacity-0
          slide-active-button:z-10 slide-active-button:relative"
          spaceBetween={15}
        >
          {isEmpty(data) ||
            data.images.map(
              (image, index) =>
                image && (
                  <SwiperSlide key={index} className="lg:!h-[393px] !h-[300px]">
                    <button
                      type="button"
                      onClick={() => openModal(index)}
                      className="h-full w-full md:relative md:z-10"
                    >
                      <LazyLoadImage
                        src={image.url}
                        alt="Dubai Sports World"
                        className="w-full h-full object-cover transition-all duration-400
                        ease-in-out"
                      />
                    </button>
                  </SwiperSlide>
                ),
            )}
        </Swiper>
      </motion.div>
      {data.images.length === 0 || (
      <div className="md:block hidden">
        <BoxedContainer>
          <div className="flex flex-row items-center gap-x-10 lg:pt-[60px] pt-[25px]">
            <div className="relative flex flex-row gap-x-4">
              <SwiperNavigationButton
                type="prev"
                clickHandler={handleClickPrev}
                icon="black-prev-arrow"
              />
              <SwiperNavigationButton
                type="next"
                clickHandler={handleClickNext}
                icon="black-next-arrow"
              />
            </div>
            <p
              className="text-primary font-roboto-regular md:text-[23px] text-[18px] md:leading-8
          leading-7 md:block hidden"
            >
              {activeSlideNumber} / {data.images.length}
            </p>
          </div>
        </BoxedContainer>
      </div>
      )}
      <div className="md:hidden block absolute top-[40%] z-10 w-full">
        <div className="relative flex flex-row gap-x-4 justify-between pl-4">
          <SwiperNavigationButton
            type="prev"
            clickHandler={handleClickPrev}
            icon="white-prev-arrow"
          />
          <SwiperNavigationButton
            type="next"
            clickHandler={handleClickNext}
            icon="white-next-arrow"
          />
        </div>
      </div>

      {modalIndex >= 0 && (
        <GalleryBlockModal
          image={data.images[modalIndex].url}
          onClick={() => closeModal()}
          toggle={() => openModal(modalIndex)}
        />
      )}
    </section>
  );
}
